import GenericModel from 'js/models/generic.model';
export default GenericModel.extend({
    urlRoot: '/CampaignCloud/UserInfo',
    url: function () {
        return this.urlRoot;
    },
    idAttribute: 'userId',
    defaults: {
        userId: 0,
        username: null,
        firstName: null,
        lastName: null,
        locale: null,
        email: null,
        creditsAvailable: 0,
        creditsReserved: 0,
        creditsSpent: 0,
        dateOfBirth: null,
        operator: false,
        professionId: 0,
        streetAddress: null,
        streetNumber: null,
        timezone: null,
        lastLogin: null,
        countryCode: null
    }
});
